import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';

import { ThemeService } from 'ngx-elvis-ds';
import { BaseComponent } from 'ngx-elvis-ds';

@Component({
  selector: 'mem-tender-card',
  templateUrl: './tender-card.component.html',
  styleUrls: ['./tender-card.component.scss']
})
export class TenderCardComponent extends BaseComponent implements OnInit, OnChanges {

  @ViewChild('button', { static: true }) button: ElementRef;
  @Input() color: String = 'primary';
  @Input() height: Number;

  @Input() icon: String;
  @Input() label: String;
  @Input() disabled: Boolean;

  constructor(
    private themes: ThemeService
  ) {
    super();
  }

  ngOnChanges() {
    this.styleInit();
  }

  ngOnInit() {
    this.styleInit(true);
    this.themes.events.subscribe(() => { this.styleInit(); });
  }

  // private

  private styleInit(setDefaults: boolean = false) {
    if (this.height) {
      this.button.nativeElement.style.setProperty('--mem-height', `${this.height}px`);
    }

    if (this.color) {
      this.button.nativeElement.style.setProperty('--mem-color', `var(--ion-color-${this.color})`);
      this.button.nativeElement.style.setProperty('--mem-color-rgb', `var(--ion-color-${this.color}-rgb)`);
      this.button.nativeElement.style.setProperty('--mem-color-tint', `var(--ion-color-${this.color}-tint)`);
      this.button.nativeElement.style.setProperty('--mem-color-tint-rgb', `var(--ion-color-${this.color}-tint-rgb)`);
      this.button.nativeElement.style.setProperty('--mem-color-shade', `var(--ion-color-${this.color}-shade)`);
      this.button.nativeElement.style.setProperty('--mem-color-shade-rgb', `var(--ion-color-${this.color}-shade-rgb)`);
      this.button.nativeElement.style.setProperty('--mem-color-contrast', `var(--ion-color-${this.color}-contrast)`);
      this.button.nativeElement.style.setProperty('--mem-color-contrast-rgb', `var(--ion-color-${this.color}-contrast-rgb)`);
    }
  }

}
